import Vue from 'vue'
import Vuex from 'vuex'

import { toSignupLogin } from './modules/toSignupLogin'
import { showCreateAccountForm } from './modules/showCreateAccountForm'
import { forgotPass } from './modules/login/ForgotPass'

// CSRF TOKEN
import { getCsrfToken } from './modules/GetCsrfToken'

// Signup
import { validationOneTwo } from './modules/signup/ValidationOneTwo'
import { validationThree } from './modules/signup/ValidationThree'
import { validationFour } from './modules/signup/ValidationFour'
import { resendMail } from './modules/signup/ResendMail'

// Admin
import { AdminActions } from  './modules/admin/admin'

// Provider
import { validateProvider } from './modules/signup/validateProvider'
import { ProviderActions } from './modules/provider/provider'

// Login
import { userLoginValidation } from './modules/login/UserLogin'
import { getUserData } from './modules/login/UserData'
import { getUtil } from './modules/login/UserUtil'
import { hospClinDoc } from './modules/login/AffiliatedFacPhy/HospClinDoc'
import { RegionProvinceCity } from './modules/login/AffiliatedFacPhy/RegionProvinceCity'
import { userConsultMembInfo } from './modules/login/Consultation/UserMembInfo'
import { annualCheckUp } from './modules/login/AnnualCheckUp/AnnualCheckUp'

import loading from './modules/loading'
Vue.use(Vuex)

export default new Vuex.Store({
    modules: {
        toSignupLogin,
        showCreateAccountForm,
        // Forgot pass
        forgotPass,
        // CSRF TOKEN
        getCsrfToken,
        // Admin
        AdminActions,
        // Provider
        validateProvider,
        ProviderActions,
        // Signup
        validationOneTwo,
        validationThree,
        validationFour,
        resendMail,
        loading,
        // Login
        userLoginValidation,
        getUserData,
        getUtil,
        RegionProvinceCity,
        hospClinDoc,
        userConsultMembInfo,
        annualCheckUp
    }
})
